import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import LoginForm from './LoginForm';
import LoginIframe from './LoginIframe';
import LoginWindow from './LoginWindow';
import ServiceUnavailableError from './ServiceUnavailableError';
import Spinner from '../../spinner';
import {
    constants as bookmakersListConstants,
} from '../../bookmakersList';

import './styles.scss';

const Login = ({
    loginType,
    isLoading,
    shouldRedirect,
    isLoginFailed,
    isGetAuthFailed,
    isIncorrectCredentials,
    authUrl,
    feed,
    registrationLink,
    showGamblingCompliance,
    actionBarClass,
    initialValues,
    cookieName,
    onSaveUsernameChange,
    onRetry,
    onLoginSubmit,
    onLoginSuccess,
    onNavigateBack,
    onErrorCancel,
}) => {
    const loginWithWindow = loginType === bookmakersListConstants.LOGIN_TYPE.WINDOW;
    const loginWithIframe = loginType === bookmakersListConstants.LOGIN_TYPE.IFRAME;
    const loginWithForm = loginType === bookmakersListConstants.LOGIN_TYPE.FORM;
    const isWindowOrIframeInfoError =
        (loginWithWindow || loginWithIframe) &&
        isGetAuthFailed;
    const serviceUnavailableError =
        (isLoginFailed && !isIncorrectCredentials) ||
        isWindowOrIframeInfoError;

    if (shouldRedirect) {
        return (<Redirect
            to={{
                pathname: '/',
                state: { isReversedAnimation: true },
            }}
        />);
    }
    if (serviceUnavailableError) {
        return (<ServiceUnavailableError
            onCancel={onErrorCancel}
            onRetry={onRetry}
            actionBarClass={actionBarClass}
        />);
    }
    return (<div>
        {
            loginWithWindow
                ? (<LoginWindow
                    cookieName={cookieName}
                    windowName="Login"
                    authUrl={authUrl}
                    onLoginSuccess={onLoginSuccess}
                    onBackClick={onNavigateBack}
                />)
                : null
        }
        {
            loginWithIframe
                ? (<LoginIframe
                    authUrl={authUrl}
                    onLoginSuccess={onLoginSuccess}
                    onBackClick={onNavigateBack}
                />)
                : null
        }
        {
            loginWithForm
                ? (<LoginForm
                    feed={feed}
                    registrationLink={registrationLink}
                    showGamblingCompliance={showGamblingCompliance}
                    actionBarClass={actionBarClass}
                    initialValues={initialValues}
                    isIncorrectCredentials={isIncorrectCredentials}
                    onSaveUsernameChange={onSaveUsernameChange}
                    onSubmit={onLoginSubmit}
                />)
                : null
        }
        <Spinner visible={isLoading} className="bs-loginPage__spinner">
            Requesting account data
        </Spinner>
    </div>);
};

Login.defaultProps = {
    isLoading: false,
    shouldRedirect: false,
    isLoginFailed: false,
    isGetAuthFailed: false,
    isIncorrectCredentials: false,
    authUrl: null,
    registrationLink: null,
    showGamblingCompliance: false,
    actionBarClass: null,
    cookieName: '',
};

Login.propTypes = {
    loginType: PropTypes.string.isRequired,
    feed: PropTypes.string.isRequired,
    initialValues: PropTypes.shape({
        saveUsername: PropTypes.bool,
        username: PropTypes.string,
    }).isRequired,

    isLoading: PropTypes.bool,
    shouldRedirect: PropTypes.bool,
    isLoginFailed: PropTypes.bool,
    isGetAuthFailed: PropTypes.bool,
    isIncorrectCredentials: PropTypes.bool,
    authUrl: PropTypes.string,
    registrationLink: PropTypes.string,
    showGamblingCompliance: PropTypes.bool,
    actionBarClass: PropTypes.string,
    cookieName: PropTypes.string,

    onSaveUsernameChange: PropTypes.func.isRequired,
    onRetry: PropTypes.func.isRequired,
    onLoginSubmit: PropTypes.func.isRequired,
    onLoginSuccess: PropTypes.func.isRequired,
    onNavigateBack: PropTypes.func.isRequired,
    onErrorCancel: PropTypes.func.isRequired,
};

export default Login;



// WEBPACK FOOTER //
// /src/js/common/loginPage/components/Login.jsx